import { defineTheme } from '../utils'

export const menuc = defineTheme({
  themeLogo: {
    image: 'hidden',
  },
  allergiesList: {
    heading: 'font-heading text-2xl',
    filterLink: 'text-base text-primary',
  },

  languageButton: {
    base: 'rounded-sm border p-2 text-black',
  },
  menuCategory: {
    title: 'font-subcategory text-4xl font-normal text-primary uppercase',
    description: 'font-heading text-2xl text-black italic',
  },
  menuItem: {
    dinner: {
      base: 'grid grid-cols-[1fr_auto] items-start gap-1',
      title: 'font-heading text-xl font-bold',
      description: 'order-2 col-span-2 text-sm',
      priceList: 'text-right text-primary',
      icons: 'order-4 col-span-2',
      label: 'order-3 col-span-2 mb-1 bg-primary p-2 font-base text-white italic',
    },
    drinks: {
      base: 'grid grid-cols-[1fr_auto] items-start gap-1',
      title: 'font-heading text-xl font-bold',
      description: 'order-2 col-span-2 text-sm',
      priceList: 'text-right text-primary',
      icons: 'order-4 col-span-2',
      label: 'order-3 col-span-2 mb-1 bg-primary p-2 font-base text-white italic',
    },
  },
  menuSubCategory: {
    title: 'font-heading text-xl font-bold text-primary',
  },
  menuTextBlock: {
    base: 'bg-primary p-4 text-center text-white',
  },
  menuTitleBlock: {
    base: 'bg-primary',
    title: 'p-2 text-center font-heading text-3xl font-bold text-white',
  },
  page: {
    heading: 'font-heading text-6xl font-bold text-black uppercase',
    container: 'border-3 border-black  p-6',
  },
  filterBar: {
    bar: 'bg-primary text-white',
    checkbox: ' accent-primary',
    closeButton: 'bg-white text-primary hover:bg-white/80',
    masterItem: 'text-black',
    itemLabel: 'text-black',
    popoverTitle: 'text-white',
    popover: 'bg-white',
    popoverHeader: 'bg-primary',
  },
})
